/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { IntlProvider } from "react-intl";

import { makeSelectLocale } from "./selectors";

type Props = {
  locale?: string;
  messages?: any;
  children: React.ReactNode;
};

export function LanguageProvider(props: Props) {
  return (
    <IntlProvider
      locale={props.locale || "en"}
      key={props.locale || "en"}
      messages={props.messages[props.locale || "EN"]}
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {};

const mapStateToProps = createSelector(makeSelectLocale(), (locale) => ({
  locale,
}));

export default connect(mapStateToProps)(LanguageProvider);
